import { render, staticRenderFns } from "./OperationDetail.vue?vue&type=template&id=0f4d5fca&scoped=true&"
import script from "./OperationDetail.vue?vue&type=script&lang=js&"
export * from "./OperationDetail.vue?vue&type=script&lang=js&"
import style0 from "./OperationDetail.vue?vue&type=style&index=0&id=0f4d5fca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d5fca",
  null
  
)

export default component.exports